import { render, staticRenderFns } from "./SuperUserRedirect.vue?vue&type=template&id=06160d20&scoped=true"
import script from "./SuperUserRedirect.vue?vue&type=script&lang=js"
export * from "./SuperUserRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06160d20",
  null
  
)

export default component.exports